<template>
  <div>
    <section class="content-header">
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> หน้าแรก
          </a>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-md-12">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">รายการคำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขายที่รอการดำเนินการ</h3>
                    </div>
                    <div class="box-body">
                      <data-tables
                        @query-change="loadData"
                        :data="cr_table"
                        :total="cr_table.length"
                        :page-size="5"
                        :pagination-props="{
                          background: true,
                          pageSizes: [5],
                          layout: 'prev, pager, next, jumper, total'
                        }"
                      >
                        <el-table-column prop="cr_status" label="สถานะการดำเนินการ">
                          <template slot-scope="item"> {{ cr_option[item.row.cr_status] }}</template>
                        </el-table-column>
                        <el-table-column prop="promotion_code" label="รหัสรายการส่งเสริมการขาย"></el-table-column>
                        <el-table-column prop="promotion_name_th" label="ชื่อรายการส่งเสริมการขาย"></el-table-column>
                        <el-table-column prop="promotion_type" label="ประเภท" width="200"></el-table-column>
                        <el-table-column prop="created_at" label="วันที่ดำเนินการ"></el-table-column>
                        <el-table-column
                            label="จัดการ"
                            width="160"
                            align="center"
                            fixed="right"
                          >
                            <template slot-scope="scope">
                              <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top" :enterable="false">
                                <el-button
                                  class="custom-btn"
                                  size="mini"
                                  type="success"
                                  @click="handleView(scope.row)"
                                >
                                  <i class="el-icon-view"></i>
                                </el-button>
                              </el-tooltip>

                              <!-- BUTTONS FOR ADMIN -->
                              <template v-if="!provider_id">
                                <el-tooltip class="item" effect="light" content="ยืนยัน" placement="top" :enterable="false" >
                                  <el-button
                                    :disabled="!(scope.row.cr_status == 'request' || scope.row.cr_status == 'waiting')"
                                    class="custom-btn"
                                    size="mini"
                                    type="primary"
                                    @click="handleEdit(scope.row,'approve')"
                                    >
                                    <i class="el-icon-check"></i>
                                  </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" content="ปฏิเสธ" placement="top" :enterable="false">
                                  <el-button
                                    :disabled="!(scope.row.cr_status == 'request' || scope.row.cr_status == 'waiting')"
                                    class="custom-btn"
                                    size="mini"
                                    type="danger"
                                    @click="handleEdit(scope.row,'reject')"
                                  >
                                    <i class="el-icon-close"></i>
                                  </el-button>
                                </el-tooltip>
                              </template>

                              <!-- BUTTONS FOR OPERATOR -->
                              <template v-else-if="edit_permission">
                                <el-tooltip v-if="scope.row.cr_status == 'approve_request'" class="item" effect="light" content="แก้ไข" placement="top" :enterable="false" >
                                  <el-button
                                    size="mini"
                                    type="primary"
                                    @click="goToUpdate(scope.row)"
                                  >
                                    <i class="el-icon-edit"></i>
                                  </el-button>
                                </el-tooltip>
                                <el-tooltip v-else-if="['reject_request','reject_edit'].includes(scope.row.cr_status)" class="item" effect="light" content="สถานะ" placement="top" :enterable="false">
                                  <el-button
                                    size="mini"
                                    type="primary"
                                    @click="handleInfo(scope.row)"
                                    >
                                      <i class="el-icon-info"></i>
                                  </el-button>
                                </el-tooltip>
                                <el-tooltip v-if="provider_id && !(scope.row.active_status == 0 && scope.row.cr_status == 'approve_request')" class="item" effect="light" content="ยกเลิกคำร้อง" placement="top" :enterable="false">
                                  <el-button
                                    class="custom-btn"
                                    size="mini"
                                    type="danger"
                                    @click="handleCancelRequest(scope.row)"
                                    >
                                    <i class="el-icon-close"></i>
                                  </el-button>
                                </el-tooltip>
                              </template>
                            </template> <!-- END SLOT SCOPE -->
                        </el-table-column>
                      </data-tables>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="col-md-6">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">พฤติกรรมการค้นหาของผู้ใช้บริการ </h3>
                      <el-form-item>
                        <el-select style="width: 50%" v-model="form.behaviorForm.provider_type" placeholder="กรุณาเลือกผู้ให้บริการ" @change="selectBehaviorChart(true)" v-if="!provider_id">
                          <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                          <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                        </el-select>
                        <el-select style="width: 50%" v-model="form.behaviorForm.search_type" placeholder="เลือก" @change="selectBehaviorChart(false)">
                          <el-option label="ประเภทการให้บริการ" value="promotion_category"></el-option>
                          <el-option label="ค่าบริการต่ำสุด" value="min_price"></el-option>
                          <el-option label="ค่าบริการสูงสุด" value="max_price"></el-option>
                          <el-option label="ปริมาณการโทร (นาที)" value="voice_minute_amount" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการโทร (บาท/นาที)" value="voice_minute_price" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="ปริมาณอินเทอร์เน็ต (GB)" value="internet_amount" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="ค่าบริการอินเทอร์เน็ต (บาท/MB)" value="internet_price" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="ความเร็วอินเทอร์เน็ต (Mbps)" value="internet_speed" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="จำนวนวันที่ให้บริการ" value="number_of_service_days" v-if="form.behaviorForm.provider_type == 'mobile'"></el-option>
                          <el-option label="ความเร็วในการดาวน์โหลด (Mbps)" value="download_speed" v-if="form.behaviorForm.provider_type == 'broadband'"></el-option>
                          <el-option label="ความเร็วในการอัปโหลด (Mbps)" value="upload_speed" v-if="form.behaviorForm.provider_type == 'broadband'"></el-option>
                          <el-option label="ประเภทบริการแพ็กเกจเสริม" value="service_on_top" v-if="form.behaviorForm.provider_type == 'broadband'"></el-option>
                          <el-option label="สิทธิพิเศษ" value="privilege"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="box-body">
                      <charts class="chart" :options="this.behavior_chart" style="max-height: 400px"></charts>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="col-md-6" v-if="!provider_id">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">จัดอันดับรายการส่งเสริมการขาย</h3>
                      <el-form-item>
                        <el-select style="width: 50%" v-model="form.rankingForm.service_type" placeholder="กรุณาเลือกผู้ให้บริการ" @change="selectRankingChart">
                          <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                          <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                        </el-select>
                        <el-select style="width: 50%" v-model="form.rankingForm.report_type" placeholder="กรุณาเลือกประเภท" @change="selectRankingChart">
                          <el-option label="ค่าบริการเหมาจ่าย" value="price"></el-option>
                          <el-option label="ความเร็วดาวน์โหลด" value="download_speed"></el-option>
                          <el-option label="ความเร็วอัปโหลด" value="upload_speed" v-if="form.rankingForm.service_type == 'broadband'"></el-option>
                          <el-option label="ปริมาณผู้ใช้งานแพ็กเกจ" value="usage"></el-option>
                          <el-option label="ปริมาณผู้เข้าชม" value="viewer"></el-option>
                          <el-option label="ปริมาณการโทร" value="voice_amount"  v-if="form.rankingForm.service_type == 'mobile'" ></el-option>
                          <el-option label="ปริมาณการส่งข้อความ SMS" value="sms_amount" v-if="form.rankingForm.service_type == 'mobile'" ></el-option>
                          <el-option label="ปริมาณการส่งรูปภาพ MMS" value="mms_amount" v-if="form.rankingForm.service_type == 'mobile'" ></el-option>
                          <el-option label="ปริมาณอินเทอร์เน็ต MB" value="internet_mb" v-if="form.rankingForm.service_type == 'mobile'" ></el-option>
                          <el-option label="ปริมาณอินเทอร์เน็ต GB" value="internet_gb" v-if="form.rankingForm.service_type == 'mobile'" ></el-option>
                          <el-option label="อัตราค่าบริการเฉลี่ยบริการเสียง" value="voice_avg" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการเฉลี่ยบริการส่งข้อความ SMS" value="sms_avg" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการเฉลี่ยบริการส่งรูปภาพ MMS" value="mms_avg" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการเฉลี่ยบริการอินเทอร์เน็ต" value="internet_avg"></el-option>
                          <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการเสียง" value="voice_fee" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งข้อความ SMS" value="sms_fee" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งรูปภาพ MMS" value="mms_fee" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                          <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการอินเทอร์เน็ต" value="internet_fee" v-if="form.rankingForm.service_type == 'mobile'"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="box-body">
                      <charts id="ranking" class="chart" :options="this.ranking_chart" style="max-height: 400px"></charts>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="col-md-6">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">โปรโมชันที่ผู้เข้าชมสูงสุด 10 อันดับ</h3>
                      <el-form-item v-if="!provider_id">
                        <el-select 
                        style="width: 50%" 
                        v-model="form.topViewForm.provider_type" 
                        placeholder="กรุณาเลือกผู้ให้บริการ" 
                        :disabled="!!this.store_provider_id" 
                        @change="selectTopView">
                          <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                          <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                        </el-select>
                        <el-select
                          style="width: 50%"
                          v-model="form.topViewForm.provider_id"
                          placeholder="โปรดเลือกชื่อผู้ให้บริการ"
                          :disabled="!!this.store_provider_id"
                          v-if="!this.store_provider_id"
                          @change="selectTopViewChart"
                        >
                          <el-option label="ทั้งหมด" value=''></el-option>
                          <el-option v-for="item in this.store_provider_list.topView" 
                            :label="item.name" 
                            :key="item.info"  
                            :value="item.info"
                          ></el-option>
                        </el-select>
                        <el-select
                          style="width: 50%"
                          v-model="form.topViewForm.provider_id"
                          placeholder="โปรดเลือกชื่อผู้ให้บริการ"
                          :disabled="!!this.store_provider_id"
                          v-else
                        >
                          <el-option 
                            :label="this.store_provider_name" 
                            :key="this.provider_id"  
                            :value="this.provider_id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="box-body">
                      <charts class="chart" :options="this.topView_chart" style="max-height: 400px"></charts>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="col-md-6" v-if="!provider_id">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่</h3>
                      <el-form-item>
                        <el-select style="width:50%;" v-model="form.G12Form.promotion_technology" @change="selectTech">
                          <el-option label="ทั้งหมด" value=""></el-option>
                          <el-option label="FTTx" value="FTTx"></el-option>
                          <el-option label="ADSL" value="ADSL"></el-option>
                          <el-option label="VDSL" value="VDSL"></el-option>
                          <el-option label="WiFi" value="WiFi"></el-option>
                          <el-option label="VAS" value="VAS"></el-option>
                        </el-select>
                        <el-select style="width:50%;" v-model="form.G12Form.service_rate" @change="selectSuffix">
                          <el-option label="บาท/Kbps" value="Kbps"></el-option>
                          <el-option label="บาท/Mbps" value="Mbps"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="box-body">
                      <charts id="ranking" class="chart" :options="this.G12_chart" style="max-height: 400px"></charts>
                    </div>
                  </div>
                </el-form>
              </div>
              <div class="col-md-12">
                <el-form>
                  <div class="box">
                    <div class="box-header with-border">
                      <h3 class="box-title">รายการนำส่งในรอบเดือนปัจจุบัน ({{ month_th[moment(new Date).subtract(1, 'M').month()] + ' พ.ศ. ' + moment(new Date).subtract(1, 'M').add(543, 'Y').format('YYYY')}}) <span style="color: red"> (นำส่งภายในวันที่ 15 {{ month_th[moment(new Date).month()] + ' พ.ศ. ' + moment(new Date).add(543, 'Y').format('YYYY')}})</span></h3>
                      <el-form-item>
                        <el-select style="width: 50%" v-model="form.monthly_regulate.provider_type" placeholder="กรุณาเลือกผู้ให้บริการ" @change="loadData(null, form.monthly_regulate)" v-if="!provider_id">
                          <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                          <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="box-body">
                      <data-tables-server
                        @query-change="loadData"
                        :data="monthly_table"
                        :total="monthly_total"
                        :page-size="5"
                        :pagination-props="{
                          background: true,
                          pageSizes: [5],
                          layout: 'prev, pager, next, jumper, total'
                        }"
                      >
                        <el-table-column prop="brand_name_th" label="ชื่อผู้ให้บริการ"></el-table-column>
                        <el-table-column prop="uploaded_at" label="วันที่นำส่ง">
                          <template slot-scope="scope">
                            {{ scope.row.uploaded_at != '-' ? scope.row.uploaded_at : '-'}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="monthly_status" label="สถานะการนำส่ง">
                           <template slot-scope="scope">
                            {{ scope.row.monthly_status == 'sent' ? 'นำส่งเรียบร้อยแล้ว' : scope.row.monthly_status == 'late' ? 'นำส่งล่าช้า' : 'ยังไม่มีการนำส่ง'}}
                          </template>
                        </el-table-column>
                      </data-tables-server>

                      <!-- VIEW CR_DIALOG -->
                      <el-dialog title="รายละเอียดการร้องขอแก้ไขข้อมูล" :visible.sync="dialogViewVisible" :width="'75%'">
                        <el-form v-model="dialogData" :label-position="'top'">
                          <el-form-item label="ตารางแสดงการเปลี่ยนแปลงข้อมูล" v-if="['waiting', 'approve_edit','reject_edit'].includes(dialogData.cr_status)">
                            <el-table :data="compare_table" border >
                              <el-table-column prop="name" label="หัวข้อที่แก้ไข"></el-table-column>
                              <el-table-column prop="old" label="ข้อมูลเก่า"></el-table-column>
                              <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                            </el-table>
                          </el-form-item>
                          <el-form-item label="รหัสรายการส่งเสริมการขาย">
                            {{dialogData.promotion_code}}
                          </el-form-item>
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            {{dialogData.promotion_name_th}}
                          </el-form-item>
                          <el-form-item label="ชื่อผู้ดำเนินการ">
                            {{dialogData.oper_name}}
                          </el-form-item>
                          <el-form-item label="ผู้ให้บริการ">
                            {{dialogData.provider_name+' ('+dialogData.brand_name_th+') ' || '-'}}
                          </el-form-item>
                          <el-form-item label="เจ้าหน้าที่ผู้ดูแลระบบ">
                            {{dialogData.admin_name || '-'}}
                          </el-form-item>
                          <el-form-item label="ข้อความ">
                            {{dialogData.cr_remark || '-'}}
                          </el-form-item>
                          <el-form-item label="วันที่ดำเนินการ">
                            {{dialogData.created_at}}
                          </el-form-item>
                        </el-form>
                      </el-dialog>

                      <!-- EDIT CR_DIALOG -->
                      <el-dialog title="จัดการการร้องขอแก้ไขข้อมูล" :visible.sync="dialogFormVisible">
                        <el-form :model="dialogForm" :label-position="'top'">
                          <el-form-item label="ตารางแสดงการเปลี่ยนแปลงข้อมูล" v-if="['approve_edit','reject_edit'].includes(dialogForm.cr_status)">
                            <el-table :data="compare_table" border >
                              <el-table-column prop="name" label="หัวข้อที่แก้ไข"></el-table-column>
                              <el-table-column prop="old" label="ข้อมูลเก่า"></el-table-column>
                              <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                            </el-table>
                          </el-form-item>
                          <el-form-item label="รหัสรายการส่งเสริมการขาย">
                            {{ dialogForm.promotion_code }}
                          </el-form-item>
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            {{dialogForm.promotion_name_th}}
                          </el-form-item>
                          <el-form-item label="จัดการ">
                            {{cr_option[dialogForm.cr_status]}}
                          </el-form-item>
                          <el-form-item label="ข้อความ">
                            <el-input v-model="dialogForm.cr_remark" type="textarea" :rows="3" show-word-limit maxlength="250"></el-input>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="dialogFormVisible = false">ปิดหน้าต่าง</el-button>
                          <el-button type="primary" @click="submit()">ตกลง</el-button>
                        </span>
                      </el-dialog>

                      <!-- CANCEL CR_DIALOG -->
                      <el-dialog title="ยกเลิกการขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogCancel" >
                        <el-form :model="dialogForm" :label-position="'top'">
                          <el-form-item label="รหัสรายการส่งเสริมการขาย">
                            {{dialogForm.promotion_code}}
                          </el-form-item>
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            {{dialogForm.promotion_name_th}}
                          </el-form-item>
                          <el-form-item label="เหตุผลการขอยกเลิกแก้ไข" >
                            <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="dialogForm.cr_remark" autocomplete="off"></el-input>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="dialogCancel = false">ปิดหน้าต่าง</el-button>
                          <el-button type="primary" @click="cancelRequest();">ยืนยัน</el-button>
                        </span>
                      </el-dialog>

                      <!-- REJECTED CR_DIALOG -->
                      <el-dialog title="สถานะคำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogReject" >
                        <el-form :model="dialogData" :label-position="'top'">
                          <el-form-item label="รหัสรายการส่งเสริมการขาย">
                            {{dialogData.promotion_code}}
                          </el-form-item>
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            {{dialogData.promotion_name_th}}
                          </el-form-item>
                          <el-form-item label="สถานะคำร้อง">
                            {{cr_option[dialogData.cr_status]}}
                          </el-form-item>
                          <el-form-item label="คำอธิบาย" >
                            {{dialogData.cr_remark}}
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="dialogReject = false">ปิดหน้าต่าง</el-button>
                          <!-- <el-button v-if="dialogData.cr_status == 'reject_request'" type="primary" @click="toRequest()">ส่งคำร้องขอแก้ไขอีกครั้ง</el-button> -->
                          <el-button v-if="dialogData.cr_status == 'reject_edit'" type="primary" @click="goToUpdate(dialogData)">ไปยังหน้าแก้ไขข้อมูล</el-button>
                        </span>
                      </el-dialog>

                      <!-- NEW REQUEST CR_DIALOG -->
                      <el-dialog title="คำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogRequest" >
                        <el-form :model="dialogData" :label-position="'top'">
                          <el-form-item label="รหัสรายการส่งเสริมการขาย">
                            {{dialogData.promotion_code}}
                          </el-form-item>
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                            {{dialogData.promotion_name_th}}
                          </el-form-item>
                          <el-form-item label="คำอธิบายการแก้ไขข้อมูล" >
                            <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="dialogData.cr_remark" autocomplete="off"></el-input>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="dialogRequest = false">ปิดหน้าต่าง</el-button>
                          <el-button type="primary" @click="sendNewRequest()">ส่งคำร้อง</el-button>
                        </span>
                      </el-dialog>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import VAChart from "../components/template/Chart";
import moment from "moment"
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  created() {
    const cookie = this.$cookies.get('user_nbtc')
    this.$store.dispatch('ListOperator/fetch_table')
    this.$store.dispatch('Dashboard/setBehaviorChart', { provider_type: this.$cookies.get('user_nbtc').provider_type || 'mobile', search_type: this.form.behaviorForm.search_type, order: "DESC" })
    this.$store.dispatch('Dashboard/setRankingChart', { service_type: "mobile", report_type: "price"})
    if(!cookie.provider_id) {
      this.$store.dispatch('Dashboard/setTopViewChart', this.form.topViewForm)
    } else {
      this.$store.dispatch('Dashboard/setTopViewChart', { provider_id: cookie.provider_id, provider_type: cookie.provider_type})
    }
    this.$store.dispatch('Dashboard/setG12Chart',  this.form.G12Form)
    this.$store.dispatch('Dashboard/getAllRequestByStatus', {
      status : ['request','approve_request','reject_request','waiting','reject_edit'],
      provider_id : cookie.provider_id
    })
  },
  data() {
    return {
      provider_id: this.store_provider_id,
      form: {
        monthly_regulate: {
          provider_type: this.$cookies.get('user_nbtc').provider_type || 'mobile',
          provider_id: this.$cookies.get('user_nbtc').provider_id
        },
        behaviorForm: {
          provider_type: this.$cookies.get('user_nbtc').provider_type || 'mobile',
          search_type: 'privilege',
          order: "DESC"
        },
        rankingForm: {
          service_type: 'mobile',
          report_type: 'price'
        },
        topViewForm: {
          provider_type: this.store_provider_type ? this.store_provider_type : 'mobile',
          provider_id: this.store_provider_id ? this.store_provider_id : '',
          provider_list : this.providers ? this.providers : []
        },
        G12Form: {
          promotion_technology: "",
          service_rate: 'Mbps',
          provider_list : []
        }
      },
      dialogForm : {},
      dialogData : {},
      dialogViewVisible : false,
      dialogFormVisible : false,
      dialogCancel : false,
      edit_permission : false,
      dialogRequest: false,
      dialogReject: false
    }
  },
  computed : {
    ...mapState({
      store_provider_id :  store => store.Dashboard.provider_id,
      store_provider_type : store => store.Dashboard.provider_type,
      store_provider_name : store => store.Dashboard.provider_name,
      store_provider_list : store=> store.Dashboard.provider_list,
      behavior_chart : store => store.Dashboard.behavior_chart,
      ranking_chart : store => store.Dashboard.ranking_chart,
      topView_chart : store => store.Dashboard.topView_chart,
      G12_chart : store => store.Dashboard.G12_chart,
      monthly_table : store => store.Dashboard.monthly_table,
      monthly_total : store => store.Dashboard.monthly_total,
      month_th : store => store.Dashboard.month_th,
      cr_table : store => store.Dashboard.cr_table,
      cr_option: store => store.Manage_request.cr_status_th,
      compare_table: store => store.Manage_request.compare_table_data
    }),
    ...mapGetters({
      providers : "ListOperator/list_all"
    })
  },
  mounted() {
    const userinfo = this.$cookies.get("user_nbtc")
    this.provider_id = userinfo.provider_id
    this.form.topViewForm.provider_id = this.provider_id != null ? this.provider_id : ''
    this.$store.dispatch('Dashboard/get_user_info')

    if(userinfo.provider_id){
      const permission = userinfo.provider_type == 'mobile' ? JSON.parse(atob(userinfo.permission)).Manage_mobile : JSON.parse(atob(userinfo.permission)).Manage_internet
      this.edit_permission = permission.includes('edit')
    }

  },
  watch : {
    store_provider_type : {
      handler : function(reload, empty){
        this.form.topViewForm.provider_type = reload != 'broadband' ? 'mobile' : reload
        this.$store.dispatch('Dashboard/setTopViewChart', this.form.topViewForm)
      }
    },
    store_provider_list : {
      handler : function(reload, empty){
        this.form.topViewForm.provider_list = reload
      }
    },
    providers : {
      handler : function(reload, empty) {
        this.form.topViewForm.provider_list = this.form.topViewForm.provider_type == 'mobile' ? this.providers.filter(item => item.type_tag == 'mobile') : this.providers.filter(item => item.type_tag == 'broadband')
        this.$store.dispatch('Dashboard/set_provider_topview', this.form.topViewForm.provider_list)
      }
    }
  },
  methods: {
    ...mapActions({
      getUserInfo: 'Dashboard/get_user_info',
      setTopViewProvider: 'Dashboard/set_provider_topview',
      behavior_search: 'Dashboard/setBehaviorChart',
      ranking_search: 'Dashboard/setRankingChart',
      topView_search: 'Dashboard/setTopViewChart',
      G12_search: 'Dashboard/setG12Chart',
      monthly_regulate_search: 'Dashboard/getCurrentMonthlyRegulate'
    }),
    selectBehaviorChart: function(change) {
      if (change) {
        this.form.behaviorForm.search_type = 'privilege'
      }
      let prepare_data = {
        provider_type: this.form.behaviorForm.provider_type,
        search_type: this.form.behaviorForm.search_type,
        order: "DESC"
      }
      this.behavior_search(prepare_data)
    },
    selectRankingChart: function(type) {
      if (type != 'mobile' && type != 'broadband') {
        let prepare_data = {
          service_type: this.form.rankingForm.service_type,
          report_type: this.form.rankingForm.report_type
        }
        this.ranking_search(prepare_data)
      } else {
        this.form.rankingForm.report_type = ''
      }
    },
    selectTopView: function(type) {
      this.form.topViewForm.provider_list = this.form.topViewForm.provider_type == 'mobile' ? this.providers.filter(item => item.type_tag == 'mobile') : this.providers.filter(item => item.type_tag == 'broadband')
      this.$store.dispatch('Dashboard/set_provider_topview', this.form.topViewForm.provider_list)
      this.form.topViewForm.provider_id = ''
      this.selectTopViewChart(this.form.topViewForm.provider_id)
    },
    selectTopViewChart: function(provider_id) {
      this.topView_search(this.form.topViewForm)
    },
    selectTech(){
      this.G12_search(this.form.G12Form)
    },
    selectSuffix(){
      this.G12_search(this.form.G12Form)
    },
    loadData(queryInfo, form) { 
      if (queryInfo) {
        if(queryInfo.type == 'sort'){
          this.form.sort = {
            prop: queryInfo.sort.prop,
            order: queryInfo.sort.order
          }
        } 
        let set_data = {
          page: queryInfo.page,
          pageSize: queryInfo.pageSize,
          form: this.form.monthly_regulate
        };
        this.monthly_regulate_search(set_data);
      } else {
        this.page = 1
        let set_data = { page: 1, pageSize: 5, form: form };
        this.monthly_regulate_search(set_data);
      }
    },
    handleView(row){
      if(row.cr_status == 'waiting' || row.cr_status == 'approve_edit'){
        var action_path = row.provider_type == 'mobile' ? 'Manage_request/getMobileEditRevision' : 'Manage_request/getBroadbandEditRevision'
        this.$store.dispatch(action_path, row.promotion_id)
      }
      this.dialogData = row
      this.dialogViewVisible = true
    },
    handleEdit(row,status){
      let mark_status = ''
      if(row.cr_status == 'request'){
        mark_status  = status == 'approve' ? 'approve_request' : 'reject_request'
      }else if(row.cr_status == 'waiting' || row.cr_status == 'approve_edit'){
        var action_path = row.provider_type == 'mobile' ? 'Manage_request/getMobileEditRevision' : 'Manage_request/getBroadbandEditRevision'
        this.$store.dispatch(action_path, row.promotion_id)
        mark_status = status == 'approve' ? 'approve_edit' : 'reject_edit'
      }
      this.dialogFormVisible = true
      this.dialogForm = Object.assign({},row)
      this.dialogForm.cr_remark = ''
      this.dialogForm.cr_status = mark_status
    },
    goToUpdate(row){
      var path = row.provider_type == 'mobile' ? 'Promotion/set_edit_promotion_detail' : 'Manage_internet/set_edit_promotion_detail'
      this.$store.dispatch(path, row.revision_id)
    },
    handleCancelRequest(row){
      this.dialogForm = row
      this.dialogForm.cr_remark = ''
      this.dialogCancel = true
    },
    cancelRequest(){
      var action_path =  this.dialogForm.provider_type == 'mobile' ? 'Manage_request/cancelMobileRequest' : 'Manage_request/cancelBroadbandRequest'
      this.$store.dispatch(action_path, this.dialogForm)
      this.dialogCancel = false
      this.$store.commit('Dashboard/REMOVE_CR_ITEM', this.dialogForm)
    },
    handleInfo(row){
      this.dialogData = row
      this.dialogReject = true
    },
    toRequest(row){
      this.dialogReject = false
      this.handleRequest(this.dialogData)
    },
    handleRequest(row){
      this.dialogData = {
        promotion_id : row.promotion_id,
        promotion_code : row.promotion_code,
        promotion_name_th : row.promotion_name_th,
        cr_status : 'request',
        cr_remark : '',
        revision_id : row.revision_id
      }
      this.dialogRequest = true
    },
    submit(){
      var formdata = {}
          formdata.dialogForm = this.dialogForm
      this.$store.dispatch('Manage_request/setRequestStatus', formdata)
      this.$store.commit('Dashboard/SET_ITEM_STATUS', this.dialogForm)
      this.dialogFormVisible = false
    },
    sendNewRequest(){
      this.dialogForm = this.dialogData
      this.submit()
    }
  }
};
</script>